import { captureException } from '@surglogs-app/error-reporting'
import { useHandler } from '@surglogs-app/hooks'

import { services } from './services/analytics'
import type {
  AnalyticsServiceCaptureEventName,
  AnalyticsServiceCaptureEventData,
} from './types'

const isTestEnvironment = () =>
  Boolean(window.Cypress) || Boolean(window.Playwright)

const pushTestEvent = <E extends AnalyticsServiceCaptureEventName>(
  name: E,
  payload?: AnalyticsServiceCaptureEventData<E>,
) => {
  if (!isTestEnvironment()) return

  window.__analyticsEvents = window.__analyticsEvents ?? []
  window.__analyticsEvents.push({
    name,
    payload,
  })
}

export const useEventCapture = () => {
  const captureEvent = useHandler(
    async <E extends AnalyticsServiceCaptureEventName>(
      name: E,
      data?: AnalyticsServiceCaptureEventData<E>,
    ) => {
      try {
        if (isTestEnvironment()) {
          pushTestEvent(name, data)
        }
        await Promise.all(services.map((s) => s.captureEvent(name, data)))
      } catch (error) {
        captureException(error)
      }
    },
  )

  return { captureEvent }
}
